import {createReducer, createActions} from 'reduxsauce';
import {
	sortQuestions,
	shuffleAnswersArray,
	shuffleInterventionAnswersArray,
	sortInterventionQuestions,
	shuffleCorrectAnswersArray,
	changeCategory,
	getInterventionQuestionImagesArray
} from '../helpers';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
	
	// start login process + loading indicators etc.
	loggingIn: null,
	// login function
	authenticate: ['data'],
	// login attempt failed
	loginFailed: ['error'],
	// login succeeded
	loginSuccessful: ['data'],
	// logout user
	logout: null,
	
	// stop fetching
	stopFetching: null,
	// fetched
	fetching: null,
	
	// start Forget Password process + loading indicators etc.
	forgetPassword: null,
	// Forget Password function
	forgetPasswordRequest: ['data'],
	// Forget Password attempt failed
	forgetPasswordFailed: ['data'],
	// Forget Password succeeded
	forgetPasswordSuccessful: ['data'],
	
	// start Update Password process + loading indicators etc.
	updatePassword: null,
	// update Password function
	updatePasswordRequest: ['data'],
	// update Password attempt failed
	updatePasswordFailed: ['data'],
	// update Password succeeded
	updatePasswordSuccessful: ['data'],
	
	// start Setting process + loading indicators etc.
	setting: null,
	// update Password function
	settingRequest: ['data'],
	// setting attempt failed
	settingFailed: ['data'],
	// setting succeeded
	settingSuccessful: ['data'],
	
	// get dashboard
	dashboardRequest: ['data'],
	getAllDashboard: ['data'],
	// assessment fetched
	dashboardFetchedSuccessfully: ['data'],
	// assessment fetch failed
	dashboardFetchFailed: ['error'],
	// assessment
	
	// get all user assessment
	assessmentRequest: ['data'],
	getAllAssessment: ['data'],
	// assessment fetched
	assessmentFetchedSuccessfully: ['data'],
	// assessment fetch failed
	assessmentFetchFailed: ['error'],
	nextQuestion: ['currentQuestionIndex', 'questionsData', 'interventionType', 'stats', 'unfilteredQuestions'],
	// submit assessment
	submitAssessment: ['data', 'token'],
	submitFirstAssessmentPhaseSuccessfully: ['data'],
	
	// interventions
	
	interventionRequest: ['data'],
	getAllIntervention: ['data'],
	// intervention fetched
	interventionFetchedSuccessfully: ['data'],
	// intervention fetch failed
	interventionFetchFailed: ['error'],
	// submit intervention
	submitIntervention: ['data', 'token'],
	// changeQuestionStatus:['status'],
	submitFirstInterventionPhaseSuccessfully: ['data'],
	nextInterventionQuestion: ['question', 'options', 'answer', 'currentIndex', 'userAnswer', 'score', 'firstPhase', 'id', 'label', 'phase', 'stats'],
	// Fetch the auth token
	fetchAuthToken: ['data'],
	// The operation has started and is loading
	fetchLoggingIn: null,
	// The auth token was successfully fetched
	fetchAuthTokenSuccess: ['authToken'],
	// An error occurred
	fetchAuthTokenFailure: ['errorMessage'],
	// Start new intervention
	startIntervention: ['startDate', 'interventionType', 'interventionPhase'],
	// Update intervention status
	updateInterventionStatus: ['status'],
	// End intervention
	endIntervention: ['endDate'],
	// End and Save Intervention
	endAndSaveIntervention: ['endDate'],
	// Get list of acquired words
	getAcquiredWords: null,
	// Update acquired words list
	updateAcquiredWords: ['acquiredWordsList'],
	// Add new acquired word
	addNewAcquiredWord: ['acquiredWord'],
	// Fetch questions data
	fetchQuestion: null,
	// Update questions data
	updateQuestions: ['questionsData'],
	// Update single question
	updateSingleQuestion: ['question', 'type', 'phase'],
	// Reset Intervention state (if consent is passed as true)
	resetIntervention: ['consent'],
	// Pause intervention
	pauseIntervention: null,
	// Resume intervention
	resumeIntervention: null,
	// Updates current question i.e., whether acquired or not, # of attempts etc.
	updateQuestion: ['questionIndex', 'question'],
	// Fetching Questions
	fetchingQuestions: null,
	// Fetched questions successfully
	questionsFetchedSuccessfully: ['questions', 'interventionType'],
	// Questions fetch failed
	questionsFetchFailed: ['error'],
	// Get questions from the server
	fetchQuestions: ['authToken', 'interventionType', 'navigation'],
	// Clicked on the right answer
	acquiredCurrentQuestion: ['question', 'answers', 'acquired', 'questionsData', 'interventionType', 'currentQuestionIndex', 'stats'],
	// Attempted to solve a question
	incrementAttempt: ['question'],
	// Reset auth token and sign in again
	resetAuthToken: ['consent'],
	// Ask question again and increment attempt
	askQuestionAgainAndIncrement: ['questions', 'currentQuestion', 'currentIndex'],
	// Fetch available actions for the user
	fetchingActions: null,
	// Actions fetched successfully
	actionsFetchSuccess: ['actions'],
	// Actions fetch failed
	actionsFetchFailed: ['error'],
	// Fetch available actions from server
	fetchActions: ['authToken'],
	// Update intervention time elapsed
	updateTimeElapsed: ['timeElapsed'],
	// Complete intervention
	finishIntervention: null,
	// Is submitting answers?
	submittingAnswers: null,
	// Answers submitted successfully
	answersSubmittedSuccessfully: null,
	// Answers submission failed
	answersSubmissionFailed: ['errorMsg'],
	// Submit Answers
	submitAnswers: ['data', 'authToken', 'navigation'],
	// Acquired assessment current question
	acquiredAssessmentQuestion: ['currentQuestion', 'answers'],
	// Attempted assessment question wrong
	failedAssessmentQuestionAttempt: ['currentQuestion', 'answers', 'currentAttemptsNumber'],
	// Assessment Part 2
	startAssessmentPart2: ['questionsData', 'interventionType'],
	// Reset assessment wrong attempts
	resetAssessmentWrongAttempts: ['consent'],
	// Resetting password
	submittingResetRequest: null,
	// Reset password request submitted successfully
	resetPasswordSuccess: ['response'],
	// Reset password request failed
	resetPasswordFailure: ['response'],
	// Reset Password
	resetPassword: ['caseId'],
	// Reset Reset Password Fields
	resetPasswordResetFields: null,
	// Update Settings
	updateSettings: ['settings'],
	// settingsUpdatedSuccessfully
	settingsUpdatedSuccessfully: ['settings'],
	// settingsUpdateFailed
	settingsUpdateFailed: ['error'],
	// Updating settings
	updatingSettings: null,
	// Submit Survey Answer
	answerSurvey: ['survey'],
	// Submitting Survey Answer
	answeringSurvey: null,
	// Survey submitted successfully
	surveyCompletedSuccessfully: null,
	// Survey submission failed
	surveyAnswerFailed: ['error'],
	// Close survey form
	hideSurveyForm: null,
	// Reset settings screen state
	resetSettingsState: null,
	// Show gift screen on dashboard
	showGiftScreen: null,
	// Hide gift screen on close click
	hideGiftScreen: null,
	// Increment local interventions count
	incrementInterventionCount: ['prevCount'],
	// Pre fetch next question images
	preFetchImages: ['questions', 'currentIndex'],
	// Touched the word
	touchedWord: null,
	// Submit intervention answers to the server and fetch actions
	submitAnswersAndFetchActions: ['data', 'authToken', 'navigation'],
	// Partially reset intervention
	partiallyResetIntervention: null,
	// Update time spent
	updateTimeSpent: ['timer'],
	// remove success message on setting screen
	removeSuccessMessage: null
	
});

export const DMTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
	authToken: null,
	loginErrorMessage: null,
	isLoggingIn: false,
	loginFormValidationMessages: null,
	user: null,
	fetching: false,
	forgetPasswordErrorMessage: null,
	isForgetPassword: false,
	isForgetPasswordSuccessfully: null,
	forgetPasswordFormValidationMessages: null,
	updatePasswordErrorMessage: null,
	isUpdatePassword: false,
	isUpdatePasswordSuccessfully: null,
	updatePasswordFormValidationMessages: null,
	settingErrorMessage: null,
	isSetting: false,
	isSettingSuccessfully: null,
	settingFormValidationMessages: null,
	dashboard: [],
	dashboardError: [],
	assessment: [],
	assessmentError: null,
	currentQuestion: null,
	currentQuestionIndex: null,
	currentQuestionValue: [],
	allQuestions: [],
	totalScore: 0,
	startTime: null,
	userQuestionsList: [],
	testPhase: null,
	firstPhaseCompleteMessage: null,
	intervention: [],
	interventionError: null,
	learningPhase: 'Listening',
	unSortedQuestions: [],
	imgStatus: null,
	testStateVar: false,
	interventionStatus: 'NOT_STARTED', // NOT_STARTED / IN_PROGRESS / PAUSED / COMPLETED
	interventionStartDate: null, // moment(new Date)
	interventionEndDate: null, // moment(new Date)
	interventionTimeAllowed: 60, // 15 minutes - ms
	interventionTimeElapsed: 0, // ms
	interventionQuestionsData: null, // questions object - attempted + un-attempted
	acquiredWords: [], // list of words acquired in this intervention
	interventionType: 'INTERVENTION', // INTERVENTION/ASSESSMENT
	fetchingQuestions: false,
	questions: null,
	questionsFetchError: null,
	answers: [], // Answers array to send to the server as an intervention result
	fetchingActions: false,
	isInterventionAvailable: false,
	isAssessmentAvailable: false,
	isSurveyAvailable: false,
	actionsFetchError: null,
	interventionPauseTime: null,
	submittingAnswers: false,
	answersSubmittedSuccessfully: false,
	answersSubmissionError: null,
	caseNumber: null,
	assessmentWrongAttempts: 0, // Max 3 allowed
	showNextQuestionArrow: false,
	assessmentPhase: 'Listening', // default assessment phase (Listening / Reading)
	numberOfPreviousAssessments: 0, // Total number of assessments attempted before this one
	submittingResetPasswordRequest: false,
	passwordResetSubmissionError: null,
	passwordResetSubmittedSuccessfully: false,
	auditoryFeedback: false, // By default auditory feedback is set to true
	rewardGameDuration: 15, // Default duration for reward game to show on game screen
	congratulationsMessage: 'You learned these words today. Please practice these words.', // Default congratulations message
	updatingSettings: false,
	updateSettingsError: null,
	settingsUpdatedSuccessfully: false,
	submittingSurvey: false,
	surveySubmittedSuccessfully: false,
	surveySubmissionError: null,
	showSurveyForm: false,
	participantStats: null,
	showGiftScreen: false,
	touchedWordAtLeastOnce: false,
	timeSpent: 0,
	nextQuestionLoaded: false,
};

/* ------------- Reducers ------------- */


export const isLoggingIn = (state, {data}) => {
	return {
		...state,
		isLoggingIn: true,
		loginFormValidationMessages: null
	};
};

export const loginFailed = (state, {error}) => {
	return {
		...state,
		isLoggingIn: false,
		loginFormValidationMessages: error
	};
};

export const loginSuccessful = (state, {data}) => {
	return {
		...state,
		isLoggingIn: false,
		forgetPasswordFormValidationMessages: null,
		updatePasswordFormValidationMessages: null,
		loginFormValidationMessages: null,
		user: data,
		authToken: data.token
	};
};

export const logout = (state) => {
	return {
		authToken: null,
		loginErrorMessage: null,
		isLoggingIn: false,
		loginFormValidationMessages: null,
		fetching: false,
		isForgetPassword: false,
		forgetPasswordErrors: null,
		isUpdatePassword: false,
		updatePasswordErrors: null,
		assessment: [],
		assessmentError: null,
		testPhase: null,
		allQuestions: null,
		userQuestionsList: null,
		currentQuestionValue: null,
		totalScore: null,
		user: null,
		forgetPasswordErrorMessage: null,
		isForgetPasswordSuccessfully: null,
		forgetPasswordFormValidationMessages: null,
		updatePasswordErrorMessage: null,
		isUpdatePasswordSuccessfully: null,
		updatePasswordFormValidationMessages: null,
		settingErrorMessage: null,
		isSetting: false,
		isSettingSuccessfully: null,
		settingFormValidationMessages: null,
		dashboard: [],
		dashboardError: [],
		currentQuestion: null,
		currentQuestionIndex: null,
		startTime: null,
		firstPhaseCompleteMessage: null,
		intervention: [],
		interventionError: null,
		learningPhase: 'Listening',
		unSortedQuestions: [],
		imgStatus: null,
		testStateVar: false,
		interventionStatus: 'NOT_STARTED', // NOT_STARTED / IN_PROGRESS / PAUSED / COMPLETED
		interventionStartDate: null, // moment(new Date)
		interventionEndDate: null, // moment(new Date)
		interventionTimeAllowed: 60, // 15 minutes - ms
		interventionTimeElapsed: 0, // ms
		interventionQuestionsData: null, // questions object - attempted + un-attempted
		acquiredWords: [], // list of words acquired in this intervention
		interventionType: 'INTERVENTION', // INTERVENTION/ASSESSMENT
		fetchingQuestions: false,
		questions: null,
		questionsFetchError: null,
		answers: [], // Answers array to send to the server as an intervention result
		fetchingActions: false,
		isInterventionAvailable: false,
		isAssessmentAvailable: false,
		isSurveyAvailable: false,
		actionsFetchError: null,
		interventionPauseTime: null,
		submittingAnswers: false,
		answersSubmittedSuccessfully: false,
		answersSubmissionError: null,
		caseNumber: null,
		assessmentWrongAttempts: 0, // Max 3 allowed
		showNextQuestionArrow: false,
		assessmentPhase: 'Listening', // default assessment phase (Listening / Reading)
		numberOfPreviousAssessments: 0, // Total number of assessments attempted before this one
		submittingResetPasswordRequest: false,
		passwordResetSubmissionError: null,
		passwordResetSubmittedSuccessfully: false,
		auditoryFeedback: false, // By default auditory feedback is set to true
		rewardGameDuration: 15, // Default duration for reward game to show on game screen
		congratulationsMessage: 'You learned these words today. Please practice these words.', // Default congratulations message
		updatingSettings: false,
		updateSettingsError: null,
		settingsUpdatedSuccessfully: false,
		submittingSurvey: false,
		surveySubmittedSuccessfully: false,
		surveySubmissionError: null,
		showSurveyForm: false,
		participantStats: null,
		showGiftScreen: false,
		touchedWordAtLeastOnce: false,
		timeSpent: 0
	};
};


export const isForgetPassword = (state, {data}) => {
	return {
		...state,
		isForgetPassword: true,
		forgetPasswordFormValidationMessages: null
	};
};

export const forgetPasswordFailed = (state, {data}) => {
	return {
		...state,
		isForgetPassword: false,
		isForgetPasswordSuccessfully: null,
		forgetPasswordErrorMessage: data
	};
};

export const forgetPasswordSuccessful = (state, {data}) => {
	
	return {
		...state,
		isForgetPassword: false,
		forgetPasswordFormValidationMessages: null,
		forgetPasswordErrorMessage: null,
		isForgetPasswordSuccessfully: data,
		userQuestionsList: null
	};
};


// Update Password

export const isUpdatePassword = (state, {data}) => {
	
	return {
		...state,
		isUpdatePassword: true,
		updatePasswordFormValidationMessages: null
	};
};

export const updatePasswordFailed = (state, {data}) => {
	
	return {
		...state,
		isUpdatePassword: false,
		isUpdatePasswordSuccessfully: null,
		updatePasswordErrorMessage: data
	};
};

export const updatePasswordSuccessful = (state, {data}) => {
	
	return {
		...state,
		isUpdatePassword: false,
		updatePasswordFormValidationMessages: null,
		updatePasswordErrorMessage: null,
		isUpdatePasswordSuccessfully: data
	};
};

// Setting

export const isSetting = (state, {data}) => {
	
	return {
		...state,
		isSetting: false,
		settingFormValidationMessages: null,
		isSettingSuccessfully: null
	};
};

export const settingFailed = (state, {data}) => {
	
	return {
		...state,
		isSetting: false,
		isSettingSuccessfully: null,
		settingErrorMessage: data
	};
};

export const settingSuccessful = (state, {data}) => {
	const settings = JSON.parse(data.participant.settings);
	// console.log(settings);
	return {
		...state,
		isSetting: true,
		settingFormValidationMessages: null,
		settingErrorMessage: null,
		isSettingSuccessfully: data,
		auditoryFeedback: settings.auditoryInstructions
	};
};


export const resetForgetPasswordState = (state) => {
	return {
		...state,
		
	};
};


const stopFetching = (state) => {
	return {
		...state,
		fetching: false
	};
};

// dashboard


const getAllDashboard = (state, {data}) => {
	return {
		...state,
		dashboard: data,
		dashboardError: null
	};
};


const dashboardFetchedSuccessfully = (state, {data}) => {
	return {
		...state,
		dashboard: data,
		dashboardError: null
	};
};

const dashboardFetchFailed = (state, {data}) => {
	return {
		...state,
		dashboardValue: [],
		dashboardErrorMessage: data,
		fetching: false
	};
};

// assessment


const getAllAssessment = (state, {data}) => {
	return {
		...state,
		assessment: data,
		assessmentError: null
	};
};


const assessmentFetchedSuccessfully = (state, {data}) => {
	if (!state.userQuestionsList) {
		state.userQuestionsList = [];
	}
	let curTime = new Date().toLocaleString();
	let sortedQuestions = null;
	if (state.testPhase === 'Listening') {
		sortedQuestions = sortQuestions(data, 'Listening', 'ASSESSMENT');
	} else {
		sortedQuestions = sortQuestions(data, 'Reading', 'ASSESSMENT');
	}
	// console.log(sortedQuestions);
	let allQuestions = sortedQuestions;
	let currentQuestion = null;
	let currentQuestionHeading = null;
	let currentQuestionOptions = null;
	let currentCorrectAnswer = null;
	let currentCorrectId = null;
	let currentQuestionValue = null;
	let currentIndex = null;
	if (sortedQuestions.length > 0) {
		if (sortedQuestions[0].distractor_image == null) {
			currentIndex = 1;
			currentQuestion = sortedQuestions[currentIndex];
			currentQuestionHeading = sortedQuestions[currentIndex].question;
		} else {
			currentIndex = 0;
			currentQuestion = sortedQuestions[currentIndex];
			currentQuestionHeading = sortedQuestions[currentIndex].question;
		}
		// console.log(currentQuestion);
		if (currentQuestion.other_images.length > 0) {
			let correctImages = shuffleCorrectAnswersArray(currentQuestion.other_images, currentQuestion.image);
			let correctImg = correctImages[0];
			let currentQuestionImages = [currentQuestion.distractor_image, correctImg, currentQuestion.optional_image, currentQuestion.optional_image_2];
			currentQuestionOptions = shuffleAnswersArray(currentQuestionImages);
			currentCorrectAnswer = correctImg;
		} else {
			let currentQuestionImages = [currentQuestion.distractor_image, currentQuestion.image, currentQuestion.optional_image, currentQuestion.optional_image_2];
			currentQuestionOptions = shuffleAnswersArray(currentQuestionImages);
			currentCorrectAnswer = currentQuestion.image;
		}
		currentCorrectId = currentQuestion.id;
		let id = sortedQuestions[currentIndex].id;
		let firstPhase = 1;
		currentQuestionValue = {
			currentQuestion,
			currentQuestionHeading,
			currentQuestionOptions,
			currentCorrectAnswer,
			currentCorrectId,
			currentIndex,
			firstPhase,
			id
		};
	}
	
	return {
		...state,
		currentQuestionValue: currentQuestionValue,
		allQuestions: allQuestions,
		assessmentError: null,
		fetching: false,
		startTime: curTime,
		testPhase: 1
	};
};

export const submitFirstAssessmentPhaseSuccessfully = (state, {data}) => {
	return {
		...state,
		userQuestionsList: null,
		testPhase: 'Listening',
		firstPhaseCompleteMessage: data,
		currentQuestionValue: null,
		currentQuestionIndex: null,
		startTime: null,
	};
};
const assessmentFetchFailed = (state, {error}) => {
	
	return {
		...state,
		assessment: [],
		assessmentError: error,
		fetching: false
	};
};


// Intervention
const getAllIntervention = (state, {data}) => {
	return {
		...state,
		intervention: data,
		interventionError: null
	};
};

const interventionFetchedSuccessfully = (state, {data}) => {
	let unSortedQuestions = data;
	if (!state.userQuestionsList) {
		state.userQuestionsList = []
	}
	let curTime = new Date().toLocaleString();
	let sortedQuestions = null;
	
	let learningPhase = 'Listening';
	
	if (learningPhase === 'Listening') {
		sortedQuestions = sortInterventionQuestions(unSortedQuestions)
	}
	let allQuestions = sortedQuestions;
	let currentQuestion = null;
	let currentQuestionHeading = null;
	let currentQuestionOptions = null;
	let currentCorrectAnswer = null;
	let currentCorrectId = null;
	let currentQuestionValue = null;
	let currentIndex = null;
	if (sortedQuestions.length > 0) {
		if (sortedQuestions[0].distractor_image === null) {
			currentIndex = 1;
			currentQuestion = sortedQuestions[currentIndex];
			currentQuestionHeading = sortedQuestions[currentIndex].question;
		} else {
			currentIndex = 0;
			currentQuestion = sortedQuestions[currentIndex];
			currentQuestionHeading = sortedQuestions[currentIndex].question;
		}
		if (currentQuestion.other_images.length > 0) {
			let correctImages = shuffleCorrectAnswersArray(currentQuestion.other_images, currentQuestion.image);
			let correctImg = correctImages[0];
			let currentQuestionImages = [currentQuestion.distractor_image, currentQuestion.optional_image, currentQuestion.optional_image_2];
			let currentQuestionOptionsTwo = shuffleAnswersArray(currentQuestionImages);
			let twoAnswers = [currentQuestionOptionsTwo[0], correctImg];
			currentQuestionOptions = shuffleInterventionAnswersArray(twoAnswers);
			currentCorrectAnswer = correctImg;
		} else {
			let currentQuestionImages = [currentQuestion.distractor_image, currentQuestion.optional_image, currentQuestion.optional_image_2];
			let currentQuestionOptionsTwo = shuffleAnswersArray(currentQuestionImages);
			let twoAnswers = [currentQuestionOptionsTwo[0], currentQuestion.image];
			currentQuestionOptions = shuffleInterventionAnswersArray(twoAnswers);
			currentCorrectAnswer = currentQuestion.image;
		}
		currentCorrectId = currentQuestion.id;
		let id = sortedQuestions[currentIndex].id;
		let firstPhase = 1;
		let imgStatus = false;
		currentQuestionValue = {
			currentQuestion,
			currentQuestionHeading,
			currentQuestionOptions,
			currentCorrectAnswer,
			currentCorrectId,
			currentIndex,
			firstPhase,
			imgStatus,
			id
		};
	}
	
	return {
		...state,
		currentQuestionValue: currentQuestionValue,
		allQuestions: allQuestions,
		assessmentError: null,
		fetching: false,
		startTime: curTime,
		learningPhase: 'Listening',
		imgStatus: false
	};
};

export const nextInterventionQuestion = (state, {question, options, answer, currentIndex, userAnswer, score, firstPhase, id, label, phase, stats}) => {
	// console.log(stats, "chal gaya ha g");
	
	if (answer === userAnswer) {
		state.totalScore = state.totalScore + 1;
	}
	if (state.currentQuestionIndex === undefined) {
		state.currentQuestionIndex = 0;
	}
	
	let acquired = null;
	if (answer === userAnswer) {
		acquired = 1;
	} else {
		acquired = 0;
	}
	let totalScore = state.totalScore;
	let currentQuestionIndex = state.currentQuestionIndex + 1;
	
	let allQuestions = state.allQuestions;
	let currentQuestion = null;
	let currentQuestionHeading = null;
	let currentQuestionOptions = null;
	let currentCorrectAnswer = null;
	let currentCorrectId = null;
	let currentQuestionValue = null;
	let previousQuestionAnswerDetail = null;
	let trials = 1;
	let attempts = 1;
	let session_start = state.startTime;
	previousQuestionAnswerDetail = {
		question,
		options,
		answer,
		currentIndex,
		userAnswer,
		score,
		firstPhase,
		acquired,
		id,
		label,
		phase,
		trials,
		attempts,
		session_start
	};
	
	
	if (allQuestions.length > 0) {
		
		
		if (allQuestions[currentQuestionIndex].distractor_image === null) {
			let currentQuestionIndex = state.currentQuestionIndex + 2;
			currentQuestion = allQuestions[currentQuestionIndex];
			currentQuestionHeading = allQuestions[currentQuestionIndex].question;
		} else {
			currentQuestion = allQuestions[currentQuestionIndex];
			currentQuestionHeading = allQuestions[currentQuestionIndex].question;
		}
		
		// console.log('Next Loaded Question For Intervention Call', currentQuestion);
		if (currentQuestion.other_images.length > 0) {
			// console.log(currentQuestion.other_images, currentQuestion.image);
			let correctImages = shuffleCorrectAnswersArray(currentQuestion.other_images, currentQuestion.image);
			let correctImg = correctImages[0];
			let currentQuestionImages = [currentQuestion.distractor_image, currentQuestion.optional_image, currentQuestion.optional_image_2];
			let currentQuestionOptionsTwo = shuffleAnswersArray(currentQuestionImages);
			let twoAnswers = [currentQuestionOptionsTwo[0], correctImg];
			currentQuestionOptions = shuffleInterventionAnswersArray(twoAnswers);
			currentCorrectAnswer = correctImg;
		} else {
			let currentQuestionImages = [currentQuestion.distractor_image, currentQuestion.optional_image, currentQuestion.optional_image_2];
			let currentQuestionOptionsTwo = shuffleAnswersArray(currentQuestionImages);
			let twoAnswers = [currentQuestionOptionsTwo[0], currentQuestion.image];
			currentQuestionOptions = shuffleInterventionAnswersArray(twoAnswers);
			currentCorrectAnswer = currentQuestion.image;
		}
		
		currentCorrectId = currentQuestion.id;
		let id = currentQuestion.id;
		currentQuestionValue = {
			currentQuestion,
			currentQuestionHeading,
			currentQuestionOptions,
			currentCorrectAnswer,
			currentCorrectId,
			currentQuestionIndex,
			totalScore,
			id,
			firstPhase,
		};
	}
	
	return {
		...state,
		totalScore: totalScore,
		currentQuestionIndex: currentQuestionIndex,
		currentQuestionValue: currentQuestionValue,
		allQuestions: allQuestions,
		assessmentError: null,
		fetching: false,
		userQuestionsList: [...state.userQuestionsList, previousQuestionAnswerDetail]
	};
	
};

export const submitFirstInterventionPhaseSuccessfully = (state, {data}) => {
	return {
		...state,
		userQuestionsList: null,
		learningPhase: 'Listening',
		firstPhaseCompleteMessage: data,
		currentQuestionValue: null,
		currentQuestionIndex: null,
		startTime: null,
	};
};


const interventionFetchFailed = (state, {error}) => {
	
	return {
		...state,
		intervention: [],
		interventionError: error,
		fetching: false
	};
};

export const fetchLoggingIn = (state) => {
	return {
		...state,
		authToken: null,
		caseNumber: null,
		isLoggingIn: true,
		loginErrorMessage: null,
	};
};

export const fetchAuthTokenSuccess = (state, { authToken }) => {
	// console.log(authToken);
	const settings = JSON.parse(authToken.settings);
	// console.log(settings);
	if (settings !== null) {
		return {
			...state,
			authToken: authToken['auth-token'],
			caseNumber: authToken.caseNumber,
			isLoggingIn: false,
			loginErrorMessage: null,
			auditoryFeedback: settings.auditoryInstructions,
			rewardGameDuration: settings.rewardGameDuration,
			congratulationsMessage: settings.congratulationsMessage,
		};
	} else {
		return {
			...state,
			authToken: authToken['auth-token'],
			caseNumber: authToken.caseNumber,
			isLoggingIn: false,
			loginErrorMessage: null,
		};
	}
};

export const fetchAuthTokenFailure = (state, { errorMessage }) => {
	return {
		...state,
		authToken: null,
		caseNumber: null,
		isLoggingIn: false,
		loginErrorMessage: errorMessage,
	};
};

export const startIntervention = (state, { startDate, interventionType, interventionPhase }) => {
	console.log(startDate, 'Intervention Start Date');
	return {
		...state,
		interventionStatus: 'IN_PROGRESS',
		interventionStartDate: startDate,
		interventionType: interventionType,
		showNextQuestionArrow: false,
		assessmentPhase: interventionPhase,
	};
};

export const updateInterventionStatus = (state, { status }) => {
	return {
		...state,
		interventionStatus: status,
	};
};

export const endIntervention = (state, { endDate }) => {
	return {
		...state,
		interventionStatus: 'COMPLETED',
		interventionEndDate: endDate,
	};
};

export const endAndSaveIntervention = (state, { endDate }) => {
	return {
		...state,
		interventionStatus: 'COMPLETED',
		interventionEndDate: endDate,
	};
};

export const updateAcquiredWords = (state, { acquiredWordsList }) => {
	return {
		...state,
		acquiredWords: acquiredWordsList,
	};
};

export const updateQuestions = (state, { questionsData }) => {
	return {
		...state,
		interventionQuestionsData: questionsData,
	};
};

export const resetIntervention = (state, { consent }) => {
	// console.log(consent);
	if (consent) {
		return {
			...state,
			interventionStatus: 'NOT_STARTED', // NOT_STARTED / IN_PROGRESS / PAUSED / COMPLETED
			interventionStartDate: null, // moment(new Date)
			interventionEndDate: null, // moment(new Date)
			interventionTimeAllowed: 900000, // 15 minutes to ms
			//interventionTimeAllowed: 300000, // 5 minutes to ms
			interventionTimeElapsed: 0, // ms
			interventionQuestionsData: null, // questions object - attempted + un-attempted
			acquiredWords: [], // list of words acquired in this intervention
			interventionType: 'INTERVENTION', // INTERVENTION/ASSESSMENT
			interventionPauseTime: null,
			submittingAnswers: false,
			answersSubmittedSuccessfully: false,
			answersSubmissionError: null,
			answers: [],
			assessmentWrongAttempts: 0,
			showNextQuestionArrow: false,
			numberOfPreviousAssessments: 0,
			touchedWordAtLeastOnce: false,
			timeSpent: 0
		};
	}
};

export const partiallyResetIntervention = (state) => {
	return {
		...state,
		interventionStatus: 'NOT_STARTED', // NOT_STARTED / IN_PROGRESS / PAUSED / COMPLETED
		interventionStartDate: null, // moment(new Date)
		interventionEndDate: null, // moment(new Date)
		interventionTimeAllowed: 900000, // 15 minutes to ms
		//interventionTimeAllowed: 300000, // 5 minutes to ms
		interventionTimeElapsed: 0, // ms
		interventionQuestionsData: null, // questions object - attempted + un-attempted
		//acquiredWords: [], // list of words acquired in this intervention
		//interventionType: 'INTERVENTION', // INTERVENTION/ASSESSMENT
		interventionPauseTime: null,
		//submittingAnswers: false,
		//answersSubmittedSuccessfully: false,
		//answersSubmissionError: null,
		assessmentWrongAttempts: 0,
		showNextQuestionArrow: false,
		numberOfPreviousAssessments: 0,
		touchedWordAtLeastOnce: false
	};
};

export const updateTimeSpent = (state, { timer }) => {
	console.log(timer, 'Assessment Timer');
	return {
		...state,
		timeSpent: timer
	};
};

export const pauseIntervention = (state) => {
	return {
		...state,
		interventionStatus: 'PAUSED',
		interventionPauseTime: new Date(),
	};
};

export const resumeIntervention = (state) => {
	return {
		...state,
		interventionStatus: 'IN_PROGRESS',
		interventionPauseTime: null
	};
};

export const nextQuestion = (state, { currentQuestionIndex, questionsData, interventionType, stats, unfilteredQuestions }) => {
	let interventionQuestionsData = questionsData;
	// console.log(currentQuestionIndex, questionsData, interventionType, stats, unfilteredQuestions);
	if (interventionType.toUpperCase() === 'INTERVENTION') {
		interventionQuestionsData = changeCategory(stats, questionsData, unfilteredQuestions);
	}
	let currentQuestion = questionsData[currentQuestionIndex + 1];
	if (interventionType.toUpperCase() === 'INTERVENTION') {
		currentQuestion.imagesArray = getInterventionQuestionImagesArray(currentQuestion);
	} else {
		currentQuestion.imagesArray = [
			currentQuestion.image,
			currentQuestion.distractor_image,
			currentQuestion.optional_image,
			currentQuestion.optional_image_2,
		];
	}
	// console.log(currentQuestion.imagesArray);
	currentQuestion.imagesArray = shuffleAnswersArray(currentQuestion.imagesArray);
	//currentQuestion = currentQuestion.setIn(['imagesArray'], shuffleAnswersArray(currentQuestion.imagesArray))
	currentQuestion = {
		...currentQuestion,
		showSecondaryImage: true,
		acquired: false,
		acquiredLocally: false
	};
	return {
		...state,
		currentQuestionIndex: currentQuestionIndex + 1,
		currentQuestion: currentQuestion,
		showNextQuestionArrow: false,
		interventionQuestionsData: interventionQuestionsData,
		touchedWordAtLeastOnce: false,
		nextQuestionLoaded: true,
	};
};

export const fetchingQuestions = (state) => {
	return {
		...state,
		fetchingQuestions: true,
	};
};

export const questionsFetchedSuccessfully = (state, { questions, interventionType }) => {
	// console.log(questions);
	const type = interventionType.toUpperCase();
	const learningPhase = 'Listening';
	let sortedQuestions = null;
	if (interventionType.toUpperCase() === 'INTERVENTION') {
		sortedQuestions = sortInterventionQuestions(questions);
	} else {
		// console.log('Assessment Question Loaded');
		sortedQuestions = sortQuestions(questions, 'Reading', type);
	}
	// console.log(sortedQuestions);
	let currentQuestion = null;
	if (sortedQuestions.length > 0) {
		currentQuestion = sortedQuestions[0];
		if (interventionType.toUpperCase() === 'INTERVENTION') {
			currentQuestion.imagesArray = getInterventionQuestionImagesArray(currentQuestion);
			//currentQuestion = currentQuestion.set('imagesArray', getInterventionQuestionImagesArray(currentQuestion))
		} else {
			currentQuestion.imagesArray = [
				currentQuestion.image,
				currentQuestion.distractor_image,
				currentQuestion.optional_image,
				currentQuestion.optional_image_2,
			];
			// currentQuestion = currentQuestion.set('imagesArray', [
			// 	currentQuestion.image,
			// 	currentQuestion.distractor_image,
			// 	currentQuestion.optional_image,
			// 	currentQuestion.optional_image_2,
			// ])
		}
		currentQuestion = {
			...currentQuestion,
			acquired: false,
			acquiredLocally: false,
			imagesArray: shuffleAnswersArray(currentQuestion.imagesArray),
			showSecondaryImage: true
		};
		// currentQuestion = currentQuestion.merge({
		// 	acquired: false,
		// 	acquiredLocally: false,
		// 	imagesArray: shuffleAnswersArray(currentQuestion.imagesArray),
		// 	showSecondaryImage: true
		// })
	}
	return {
		...state,
		fetchingQuestions: false,
		questionsFetchError: null,
		questions: questions,
		interventionQuestionsData: sortedQuestions,
		currentQuestion: currentQuestion,
		currentQuestionIndex: 0,
		showNextQuestionArrow: false,
		numberOfPreviousAssessments: questions.stats.interventions,
		participantStats: questions.stats,
	};
};

export const questionsFetchFailed = (state, { error }) => {
	let errorMsg = error
	if (!error || error === '') {
		errorMsg = 'Something went wrong. Try again.'
	}
	return {
		...state,
		fetchingQuestions: false,
		questionsFetchError: errorMsg,
		questions: null,
		interventionQuestionsData: null,
	};
};

export const incrementAttempt = (state, { question }) => {
	let currentQuestion = question
	currentQuestion.attempts = currentQuestion.attempts + 1
	currentQuestion.attempts = currentQuestion.attempts + 1
	//currentQuestion = currentQuestion.setIn(['attempts'], (currentQuestion.attempts + 1))
	if (currentQuestion.attempts >= 2) {
		currentQuestion.showSecondaryImage = false;
		//currentQuestion = currentQuestion.setIn(['showSecondaryImage'], false)
	} else {
		currentQuestion.showSecondaryImage = true;
		//currentQuestion = currentQuestion.setIn(['showSecondaryImage'], true)
	}
	return {
		...state,
		currentQuestion
	};
};

export const acquiredCurrentQuestion = (state, { question, answers, acquired, questionsData, interventionType, currentQuestionIndex, stats }) => {
	let questions = questionsData;
	let currentQuestion = question;
	currentQuestion.attempts = currentQuestion.attempts + 1;
	currentQuestion.showSecondaryImage = false;
	currentQuestion.trials = currentQuestion.trials + 1;
	currentQuestion.localTrials = currentQuestion.localTrials + 1;
	if (acquired) {
		currentQuestion = {
			...currentQuestion,
			acquired: true,
			acquiredLocally: true,
		};
	} else {
		currentQuestion = {
			...currentQuestion,
			acquired: false,
			acquiredLocally: true,
		};
	}
	if (currentQuestion.localTrials === 1) {
		currentQuestion.trialStats.first = acquired;
	} else if (currentQuestion.localTrials === 2) {
		currentQuestion.trialStats.second = acquired;
	} else {
		currentQuestion.trialStats.third = acquired;
	}
	let isQuestionAcquired = false;
	if (
		(currentQuestion.trialStats.first && currentQuestion.trialStats.second) ||
		(currentQuestion.trialStats.first && currentQuestion.trialStats.third) ||
		(currentQuestion.trialStats.second && currentQuestion.trialStats.third)
	) {
		isQuestionAcquired = true;
	}
	let answersArray = answers;
	let participantStats = stats;
	let userQuestionsList = state.userQuestionsList ? state.userQuestionsList.concat([]) : [];
	const hadAnyCorrect = !!(currentQuestion.trialStats.first || currentQuestion.trialStats.second || currentQuestion.trialStats.third);
	const finalAcquiredStatus = hadAnyCorrect || isQuestionAcquired;
	
	// Find if this question already exists in answers array
	const existingAnswerIndex = answersArray.findIndex((e) => e.id === currentQuestion.id && e.phase && e.phase.toUpperCase() === currentQuestion.phase.toUpperCase());
	
	// Always add or update the answer to track ALL attempts:
	// Add on first attempt, then update on every subsequent attempt to track:
	// - Total attempts (attempts field)
	// - Number of trials (localTrials)
	// - Trial stats (which attempts were correct/incorrect)
	// - Final acquired status (whether user got it right at least once)
	// This ensures ALL questions are tracked: correct, incorrect, and those requiring multiple attempts
	const shouldAddOrUpdate = existingAnswerIndex !== -1 || isQuestionAcquired || hadAnyCorrect || currentQuestion.localTrials % 3 === 0 || currentQuestion.localTrials === 1;
	
	if (shouldAddOrUpdate) {
		if (existingAnswerIndex !== -1) {
			// Update existing answer with latest attempt count and acquired status
			answersArray[existingAnswerIndex] = {
				...answersArray[existingAnswerIndex],
				...currentQuestion,
				acquired: finalAcquiredStatus,
				attempts: currentQuestion.attempts,
				localTrials: currentQuestion.localTrials,
				trialStats: currentQuestion.trialStats,
			};
		} else {
			// Add new answer with all attempt information
			answersArray = answersArray.concat({
				...currentQuestion,
				acquired: finalAcquiredStatus,
			});
		}
		
		// Mirror to userQuestionsList so the complete page has a fallback source
		const existingUserListIndex = userQuestionsList.findIndex((e) => e.id === currentQuestion.id && e.phase && e.phase.toUpperCase() === currentQuestion.phase.toUpperCase());
		if (existingUserListIndex !== -1) {
			// Update existing entry
			userQuestionsList[existingUserListIndex] = {
				...userQuestionsList[existingUserListIndex],
				...currentQuestion,
				acquired: finalAcquiredStatus,
				attempts: currentQuestion.attempts,
				localTrials: currentQuestion.localTrials,
				trialStats: currentQuestion.trialStats,
			};
		} else {
			// Add new entry
			userQuestionsList.push({
				...currentQuestion,
				acquired: finalAcquiredStatus,
			});
		}
	}
	// Reinsertion logic adjusted to push to end to avoid tight 3-item loop
	if (currentQuestion.phase.toUpperCase() === 'LISTENING') {
		if (isQuestionAcquired) {
			questions.push({
				...currentQuestion,
				imagesArray: getInterventionQuestionImagesArray(currentQuestion),
				acquired: false,
				acquiredLocally: false,
				attempts: 0,
				phase: 'Reading',
				localTrials: 0,
				trialStats: {
					first: false,
					second: false,
					third: false,
				},
			});
		} else {
			if (currentQuestion.localTrials % 3 !== 0) {
				questions.push({
					...currentQuestion,
					imagesArray: getInterventionQuestionImagesArray(currentQuestion),
					acquired: false,
					acquiredLocally: false,
					attempts: 0,
				});
			}
		}
	} else {
		if (!isQuestionAcquired) {
			if (currentQuestion.localTrials % 3 !== 0) {
				questions.push({
					...currentQuestion,
					imagesArray: getInterventionQuestionImagesArray(currentQuestion),
					acquired: false,
					acquiredLocally: false,
					attempts: 0,
				});
			}
		}
	}
	currentQuestion = {
		...currentQuestion,
		image: currentQuestion.imagesArray[0],
	};
	return {
		...state,
		currentQuestion,
		answers: answersArray,
		showNextQuestionArrow: true,
		interventionQuestionsData: questions,
		participantStats: participantStats,
		userQuestionsList: userQuestionsList,
	};
};

export const resetAuthToken = (state, { consent }) => {
	if (consent) {
		return {
			...state,
			authToken: null,
			loginErrorMessage: null
		};
	}
};

export const askQuestionAgainAndIncrement = (state, { questions, currentQuestion, currentIndex }) => {
	let question = currentQuestion
	question = {
		...question,
		attempts: question.attempts + 1
	}
	return {
		...state,
		currentQuestion: question
	};
};

export const actionsFetchSuccess = (state, { actions }) => {
	// console.log(actions);
	let showSurveyForm = false
	if (actions.survey) {
		showSurveyForm = true
	} else {
		showSurveyForm = false
	}
	return {
		...state,
		isAssessmentAvailable: actions.assessment,
		isInterventionAvailable: actions.intervention,
		isSurveyAvailable: actions.survey,
		fetchingActions: false,
		actionsFetchError: null,
		submittingSurvey: false,
		surveySubmittedSuccessfully: false,
		surveySubmissionError: null,
		showSurveyForm: showSurveyForm,
	};
};

export const actionsFetchFailed = (state, { error }) => {
	let errorMsg = error
	if (!error || error === '') {
		errorMsg = 'Something went wrong. Try again.'
	}
	return {
		...state,
		actionsFetchError: errorMsg,
		fetchingActions: false,
		submittingSurvey: false,
		surveySubmittedSuccessfully: false,
		surveySubmissionError: null,
		showSurveyForm: false,
	};
};

export const fetchingActions = (state) => {
	return {
		...state,
		fetchingActions: true,
	};
};

export const updateTimeElapsed = (state, { timeElapsed }) => {
	return {
		...state,
		interventionTimeElapsed: timeElapsed,
	};
};

export const finishIntervention = (state) => {
	return {
		...state,
		interventionStatus: 'COMPLETED', // NOT_STARTED / IN_PROGRESS / PAUSED / COMPLETED
		interventionEndDate: new Date(), // moment(new Date)
	};
};

export const submittingAnswers = (state) => {
	return {
		...state,
		submittingAnswers: true,
		answersSubmissionError: null,
		answersSubmittedSuccessfully: false,
	};
};

export const answersSubmittedSuccessfully = (state) => {
	return {
		...state,
		submittingAnswers: false,
		answersSubmittedSuccessfully: true,
		answersSubmissionError: null,
	};
};

export const answersSubmissionFailed = (state, { errorMsg }) => {
	let message = errorMsg
	// console.log(errorMsg);
	if (message !== null && message !== '') {
		message = 'Something went wrong. Please try again.'
	}
	return {
		...state,
		submittingAnswers: false,
		answersSubmittedSuccessfully: false,
		answersSubmissionError: errorMsg,
	};
};

export const acquiredAssessmentQuestion = (state, { currentQuestion, answers }) => {
	let question = currentQuestion
	question.acquired = true;
	//question = question.setIn(['acquired'], true)
	question.attempts = question.attempts + 1;
	//question = question.setIn(['attempts'], (question.attempts + 1))
	let answersArray = answers
	answersArray = answersArray.concat(question)
	return {
		...state,
		currentQuestion: question,
		answers: answersArray,
		assessmentWrongAttempts: 0,
	};
};

export const failedAssessmentQuestionAttempt = (state, { currentQuestion, answers, currentAttemptsNumber }) => {
	let question = currentQuestion
	question.acquired = false;
	//question = question.setIn(['acquired'], false)
	question.attempts = question.attempts + 1;
	//question = question.setIn(['attempts'], (question.attempts + 1))
	let answersArray = answers
	answersArray = answersArray.concat(question)
	return {
		...state,
		currentQuestion: question,
		answers: answersArray,
		assessmentWrongAttempts: currentAttemptsNumber + 1,
	};
};

export const startAssessmentPart2 = (state, { questionsData, interventionType }) => {
	const questions = questionsData
	const type = interventionType.toUpperCase()
	const learningPhase = 'Listening'
	const sortedQuestions = sortQuestions(questions, learningPhase, type)
	let currentQuestion = sortedQuestions[0]
	currentQuestion.imagesArray = [
		currentQuestion.image,
		currentQuestion.distractor_image,
		currentQuestion.optional_image,
		currentQuestion.optional_image_2,
	];
	// currentQuestion = currentQuestion.set('imagesArray', [
	// 	currentQuestion.image,
	// 	currentQuestion.distractor_image,
	// 	currentQuestion.optional_image,
	// 	currentQuestion.optional_image_2,
	// ])
	currentQuestion = {
		...currentQuestion,
		acquired: false,
		acquiredLocally: false,
		imagesArray: shuffleAnswersArray(currentQuestion.imagesArray),
		showSecondaryImage: true
	}
	return {
		...state,
		fetchingQuestions: false,
		questionsFetchError: null,
		questions: questions,
		interventionQuestionsData: sortedQuestions,
		currentQuestion: currentQuestion,
		currentQuestionIndex: 0,
		showNextQuestionArrow: false,
		assessmentPhase: learningPhase,
		interventionStatus: 'IN_PROGRESS'
	};
};

export const resetAssessmentWrongAttempts = (state, { consent }) => {
	if (consent) {
		return {
			...state,
			assessmentWrongAttempts: 0,
		};
	}
};

export const resetPasswordSuccess = (state, { response }) => {
	return {
		...state,
		submittingResetPasswordRequest: false,
		passwordResetSubmittedSuccessfully: true,
		passwordResetSubmissionError: null,
	};
};

export const resetPasswordFailure = (state, { response }) => {
	return {
		...state,
		submittingResetPasswordRequest: false,
		passwordResetSubmissionError: response,
		passwordResetSubmittedSuccessfully: false,
	}
}

export const submittingResetRequest = (state) => {
	return {
		...state,
		submittingResetPasswordRequest: true,
		passwordResetSubmittedSuccessfully: false,
		passwordResetSubmissionError: null,
	}
}

export const resetPasswordResetFields = (state) => {
	return {
		...state,
		submittingResetPasswordRequest: false,
		passwordResetSubmissionError: null,
		passwordResetSubmittedSuccessfully: false,
	}
}

export const settingsUpdatedSuccessfully = (state, { settings }) => {
	return {
		...state,
		auditoryFeedback: settings.auditoryFeedback,
		rewardGameDuration: settings.rewardGameDuration,
		congratulationsMessage: settings.congratulationsMessage,
		updatingSettings: false,
		updateSettingsError: null,
		settingsUpdatedSuccessfully: true,
	}
}

export const settingsUpdateFailed = (state, { error }) => {
	let errorMessage = error
	if (error !== null && error !== '') {
		errorMessage = error
	} else {
		errorMessage = 'Something went wrong. Please try again.'
	}
	return {
		...state,
		updatingSettings: false,
		updateSettingsError: errorMessage,
		settingsUpdatedSuccessfully: false,
	}
}

export const updatingSettings = (state) => {
	return {
		...state,
		updatingSettings: true,
		updateSettingsError: null,
		settingsUpdatedSuccessfully: false,
	}
}

export const answeringSurvey = (state) => {
	return {
		...state,
		submittingSurvey: true,
		surveySubmittedSuccessfully: false,
		surveySubmissionError: null,
	}
}

export const surveyCompletedSuccessfully = (state) => {
	return {
		...state,
		submittingSurvey: false,
		surveySubmittedSuccessfully: true,
		surveySubmissionError: null,
		showSurveyForm: false,
	}
}

export const surveyAnswerFailed = (state, { error }) => {
	let errorMessage = error
	if (error !== null && error !== '') {
		errorMessage = error
	} else {
		errorMessage = 'Something went wrong. Please try again.'
	}
	return {
		...state,
		submittingSurvey: false,
		surveySubmittedSuccessfully: false,
		surveySubmissionError: errorMessage,
	}
}

export const hideSurveyForm = (state) => {
	return {
		...state,
		showSurveyForm: false,
	}
}

export const resetSettingsState = (state) => {
	return {
		...state,
		updatingSettings: false,
		updateSettingsError: null,
		settingsUpdatedSuccessfully: false,
	}
}

export const showGiftScreen = (state) => {
	return {
		...state,
		showGiftScreen: true
	}
}

export const hideGiftScreen = (state) => {
	return {
		...state,
		showGiftScreen: false
	}
}

export const incrementInterventionCount = (state, { prevCount }) => {
	return {
		...state,
		numberOfPreviousAssessments: prevCount + 1,
	}
}

export const touchedWord = (state) => {
	return {
		...state,
		touchedWordAtLeastOnce: true
	}
}

export const removeSuccessMessage = (state) => {
	return {
		...state,
		isSetting: false
		// isSettingSuccessfully: null
	}
}


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
	[Types.LOGGING_IN]: isLoggingIn,
	[Types.LOGIN_FAILED]: loginFailed,
	[Types.LOGIN_SUCCESSFUL]: loginSuccessful,
	[Types.LOGOUT]: logout,
	// [Types.FETCHING]: fetching,
	[Types.STOP_FETCHING]: stopFetching,
	
	[Types.FORGET_PASSWORD]: isForgetPassword,
	[Types.FORGET_PASSWORD_FAILED]: forgetPasswordFailed,
	[Types.FORGET_PASSWORD_SUCCESSFUL]: forgetPasswordSuccessful,
	
	[Types.UPDATE_PASSWORD]: isUpdatePassword,
	[Types.UPDATE_PASSWORD_FAILED]: updatePasswordFailed,
	[Types.UPDATE_PASSWORD_SUCCESSFUL]: updatePasswordSuccessful,
	
	[Types.SETTING]: isSetting,
	[Types.SETTING_FAILED]: settingFailed,
	[Types.SETTING_SUCCESSFUL]: settingSuccessful,
	
	[Types.GET_ALL_DASHBOARD]: getAllDashboard,
	[Types.DASHBOARD_FETCHED_SUCCESSFULLY]: dashboardFetchedSuccessfully,
	[Types.DASHBOARD_FETCH_FAILED]: dashboardFetchFailed,
	
	[Types.ASSESSMENT_FETCH_FAILED]: assessmentFetchFailed,
	[Types.ASSESSMENT_FETCHED_SUCCESSFULLY]: assessmentFetchedSuccessfully,
	[Types.GET_ALL_ASSESSMENT]: getAllAssessment,
	
	[Types.NEXT_QUESTION]: nextQuestion,
	[Types.SUBMIT_FIRST_ASSESSMENT_PHASE_SUCCESSFULLY]: submitFirstAssessmentPhaseSuccessfully,
	
	
	[Types.INTERVENTION_FETCH_FAILED]: interventionFetchFailed,
	[Types.INTERVENTION_FETCHED_SUCCESSFULLY]: interventionFetchedSuccessfully,
	[Types.GET_ALL_INTERVENTION]: getAllIntervention,
	
	[Types.NEXT_INTERVENTION_QUESTION]: nextInterventionQuestion,
	[Types.SUBMIT_FIRST_INTERVENTION_PHASE_SUCCESSFULLY]: submitFirstInterventionPhaseSuccessfully,
	
	
	[Types.FETCH_LOGGING_IN]: fetchLoggingIn,
	[Types.FETCH_AUTH_TOKEN_SUCCESS]: fetchAuthTokenSuccess,
	[Types.FETCH_AUTH_TOKEN_FAILURE]: fetchAuthTokenFailure,
	[Types.START_INTERVENTION]: startIntervention,
	[Types.UPDATE_INTERVENTION_STATUS]: updateInterventionStatus,
	[Types.END_INTERVENTION]: endIntervention,
	[Types.END_AND_SAVE_INTERVENTION]: endAndSaveIntervention,
	[Types.UPDATE_ACQUIRED_WORDS]: updateAcquiredWords,
	[Types.UPDATE_QUESTIONS]: updateQuestions,
	[Types.RESET_INTERVENTION]: resetIntervention,
	[Types.PAUSE_INTERVENTION]: pauseIntervention,
	[Types.RESUME_INTERVENTION]: resumeIntervention,
	[Types.NEXT_QUESTION]: nextQuestion,
	[Types.FETCHING_QUESTIONS]: fetchingQuestions,
	[Types.QUESTIONS_FETCHED_SUCCESSFULLY]: questionsFetchedSuccessfully,
	[Types.QUESTIONS_FETCH_FAILED]: questionsFetchFailed,
	[Types.LOGOUT]: logout,
	[Types.INCREMENT_ATTEMPT]: incrementAttempt,
	[Types.ACQUIRED_CURRENT_QUESTION]: acquiredCurrentQuestion,
	[Types.RESET_AUTH_TOKEN]: resetAuthToken,
	[Types.ASK_QUESTION_AGAIN_AND_INCREMENT]: askQuestionAgainAndIncrement,
	[Types.ACTIONS_FETCH_SUCCESS]: actionsFetchSuccess,
	[Types.ACTIONS_FETCH_FAILED]: actionsFetchFailed,
	[Types.FETCHING_ACTIONS]: fetchingActions,
	[Types.UPDATE_TIME_ELAPSED]: updateTimeElapsed,
	[Types.FINISH_INTERVENTION]: finishIntervention,
	[Types.SUBMITTING_ANSWERS]: submittingAnswers,
	[Types.ANSWERS_SUBMITTED_SUCCESSFULLY]: answersSubmittedSuccessfully,
	[Types.ANSWERS_SUBMISSION_FAILED]: answersSubmissionFailed,
	[Types.ACQUIRED_ASSESSMENT_QUESTION]: acquiredAssessmentQuestion,
	[Types.FAILED_ASSESSMENT_QUESTION_ATTEMPT]: failedAssessmentQuestionAttempt,
	[Types.START_ASSESSMENT_PART2]: startAssessmentPart2,
	[Types.RESET_ASSESSMENT_WRONG_ATTEMPTS]: resetAssessmentWrongAttempts,
	[Types.RESET_PASSWORD_SUCCESS]: resetPasswordSuccess,
	[Types.RESET_PASSWORD_FAILURE]: resetPasswordFailure,
	[Types.SUBMITTING_RESET_REQUEST]: submittingResetRequest,
	[Types.RESET_PASSWORD_RESET_FIELDS]: resetPasswordResetFields,
	[Types.SETTINGS_UPDATED_SUCCESSFULLY]: settingsUpdatedSuccessfully,
	[Types.SETTINGS_UPDATE_FAILED]: settingsUpdateFailed,
	[Types.UPDATING_SETTINGS]: updatingSettings,
	[Types.ANSWERING_SURVEY]: answeringSurvey,
	[Types.SURVEY_COMPLETED_SUCCESSFULLY]: surveyCompletedSuccessfully,
	[Types.SURVEY_ANSWER_FAILED]: surveyAnswerFailed,
	[Types.HIDE_SURVEY_FORM]: hideSurveyForm,
	[Types.RESET_SETTINGS_STATE]: resetSettingsState,
	[Types.SHOW_GIFT_SCREEN]: showGiftScreen,
	[Types.HIDE_GIFT_SCREEN]: hideGiftScreen,
	[Types.INCREMENT_INTERVENTION_COUNT]: incrementInterventionCount,
	[Types.TOUCHED_WORD]: touchedWord,
	[Types.PARTIALLY_RESET_INTERVENTION]: partiallyResetIntervention,
	[Types.UPDATE_TIME_SPENT]: updateTimeSpent,
	[Types.REMOVE_SUCCESS_MESSAGE]: removeSuccessMessage,

});